import { createContext } from "react";
import { IIndicators, emptyIndicator } from "../../../../types/Indicators.type";

type InitialStateType = {
  indicator: IIndicators;
  saveIndicator: (renterData: IIndicators) => Promise<{
    ok: boolean;
    data: IIndicators;
    errors: Array<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      message: string | any;
      path: string[] | never[];
    }>;
  }>;
};


export const initialState: InitialStateType = {
  indicator: emptyIndicator(),
  saveIndicator: () =>
    Promise.reject({
      ok: false,
      data: emptyIndicator(),
      errors: [
        {
          message: "not-implemented",
          path: ["."]
        }
      ]
    })
};

// Context separado
export const IndicatorDashboardContext = createContext(initialState);
